import { labelReducer } from './label.reducer';
import { myAccountReducer } from './my-account.reducer';
import { myProfileReducer } from './my-profile.reducer';
import { mySuccessManagerReducer } from './my-success-manager.reducer';
import { userManagementReducer } from './user-management.reducer';

export const reducers  = {
    account: myAccountReducer,
    successManager: mySuccessManagerReducer,
    labels: labelReducer,
    countriesAndLanguages: userManagementReducer,
    profile: myProfileReducer
};
